/* eslint-disable react/no-unused-prop-types */
/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
} from 'semantic-ui-react';

export default class DropdownInputNumber extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string.isRequired,
    minValue: PropTypes.number,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    presetOptions: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      text: PropTypes.string,
      value: PropTypes.string,
    })),
  }
  static defaultProps = {
    minValue: 1,
  }
  static getPropsToState = (props) => {
    const newProps = {
      presetOptions: [...DropdownInputNumber.defaultOptions],
    };
    if (props.presetOptions) {
      newProps.presetOptions = [...props.presetOptions];
    }
    if (props.value) {
      const optionExists = newProps.presetOptions.findIndex(po => po.value === props.value);
      if (optionExists === -1) {
        newProps.presetOptions = [
          { key: props.value, text: props.value, value: props.value },
          ...newProps.presetOptions,
        ];
      }
      newProps.value = props.value;
    }
    return newProps;
  }
  static defaultOptions = [
    { key: 'o15', text: '15 (15 Minutes)', value: '15' },
    { key: 'o30', text: '30 (30 Minutes)', value: '30' },
    { key: 'o60', text: '60 (1 Hour)', value: '60' },
    { key: 'o180', text: '180 (3 Hours)', value: '180' },
    { key: 'o360', text: '360 (6 Hours)', value: '360' },
    { key: 'o720', text: '720 (12 Hours)', value: '720' },
    { key: 'o1440', text: '1440 (1 Day)', value: '1440' },
  ]
  constructor(props) {
    super(props);
    const state = DropdownInputNumber.getPropsToState(props);
    this.state = {
      ...state,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = DropdownInputNumber.getPropsToState(nextProps);
    if ((JSON.stringify(this.state.value) !== JSON.stringify(state.value)) && state.value !== '') {
      this.setState({ ...state });
    }
  }
  handleAddition = (e, { value }) => {
    let numberVal = value.replace(/\D/g, '').substring(0, 9);
    if (!numberVal) numberVal = this.props.minValue;
    let { presetOptions } = this.state;
    const exists = this.state.presetOptions.findIndex(co => co.value === numberVal);
    if (exists === -1) {
      presetOptions = [{ key: numberVal, text: numberVal, value: numberVal }, ...this.state.presetOptions];
    }
    this.setState({
      presetOptions,
      value: numberVal,
    });
  }
  handleChange = (e, d) => {
    this.setState({ value: d.value }, () => {
      if (this.props.onChange) this.props.onChange(d.value, d);
    });
  }
  render() {
    const { disabled, label, name, placeholder } = this.props;
    const { presetOptions, value } = this.state;
    return (
      <Form.Select
        label={label}
        options={presetOptions}
        placeholder={placeholder}
        name={name}
        search
        selection
        fluid
        allowAdditions
        onAddItem={this.handleAddition}
        value={value}
        onChange={this.handleChange}
        disabled={disabled}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DropdownInputNumber.jsx